define(function(require){
    'use strict';

    var Rivets = require('rivets');

    Rivets.binders['background-color'] = function(el, value) {
        el.style.backgroundColor = value
    }
});